import React from 'react';
import { Heart } from 'lucide-react';
export function Footer() {
  const checkoutUrl = 'https://kreanacrochet.com/cart/add?id=52738305032303&quantity=1';
  return <footer className="bg-deep-brown text-white/80 py-12" data-id="element-98">
      <div className="max-w-5xl mx-auto px-4" data-id="element-99">
        {/* Final CTA */}
        <div className="text-center mb-12 pb-12 border-b border-white/10" data-id="element-100">
          <p className="font-heading text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-101">
            ¿Lista para tejer a tu mascota?
          </p>
          <p className="text-white/60 mb-6 text-sm max-w-md mx-auto" data-id="element-102">
            Tu compañero peludo merece ser inmortalizado. Empieza hoy.
          </p>
          <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="inline-block px-8 py-3.5 bg-white text-deep-brown rounded-full font-bold hover:bg-cream transition-colors shadow-lg" data-id="element-103">
            Quiero Mi Ebook Ahora
          </a>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-104">
          <div className="text-center md:text-left" data-id="element-105">
            <div className="flex items-center justify-center md:justify-start gap-2 mb-2" data-id="element-106">
              <Heart size={14} className="text-soft-rose fill-soft-rose" data-id="element-107" />
              <span className="font-heading font-bold text-lg text-white" data-id="element-108">
                KreanaCrochet
              </span>
            </div>
            <p className="text-xs text-white/40" data-id="element-109">
              Tejiendo recuerdos, una puntada a la vez.
            </p>
          </div>

          <div className="flex gap-6 text-xs font-medium text-white/50" data-id="element-110">
            <a href="#" className="hover:text-white transition-colors" data-id="element-111">
              Términos
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-112">
              Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-113">
              Contacto
            </a>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-white/10 text-center text-xs text-white/30" data-id="element-114">
          © {new Date().getFullYear()} KreanaCrochet. Todos los derechos
          reservados.
        </div>
      </div>
    </footer>;
}